
// Protezione contro caricamenti multipli
if (typeof window.vortexProductShowcaseLoaded !== 'undefined') {
    console.log('Vortex Product Showcase già caricato, skip...');
} else {
    window.vortexProductShowcaseLoaded = true;

// Toggle Benchmark Table
window.toggleBenchmark = function() {
    const table = document.getElementById('benchmarkTable');
    const button = document.querySelector('.bb');
    const chevron = document.getElementById('chevron');
    
    if (!table || !button || !chevron) return;
    
    const isOpening = !table.classList.contains('active');
    
    table.classList.toggle('active');
    button.classList.toggle('active');
    chevron.style.transform = table.classList.contains('active') ? 'rotate(180deg)' : 'rotate(0deg)';
    
    // Anima gli FPS quando si apre la tabella
    if (isOpening) {
        // Resetta immediatamente tutti gli FPS a 0
        const allFpsElements = table.querySelectorAll('.fb');
        allFpsElements.forEach(fpsElement => {
            fpsElement.setAttribute('data-original-value', fpsElement.textContent);
            fpsElement.textContent = '0 FPS';
        });
        
        // Aspetta che l'animazione CSS di apertura finisca (0.6s)
        setTimeout(() => {
            allFpsElements.forEach(fpsElement => {
                const originalValue = fpsElement.getAttribute('data-original-value');
                const finalValue = parseInt(originalValue.replace(/[^\d]/g, ''));
                if (!isNaN(finalValue)) {
                    animateFPS(fpsElement, finalValue);
                }
            });
        }, 600); // 600ms (animazione CSS)
    }
}

// Change Resolution (Mobile)
window.changeResolution = function(resolution) {
    const allColumns = document.querySelectorAll('.fps-1080p, .fps-1440p, .fps-4k');
    allColumns.forEach(col => col.style.display = 'none');
    
    const selectedColumns = document.querySelectorAll('.fps-' + resolution);
    selectedColumns.forEach(col => col.style.display = 'table-cell');
    
    // Anima i numeri FPS nelle colonne selezionate
    selectedColumns.forEach(col => {
        const fpsElement = col.querySelector('.fb');
        if (fpsElement) {
            const finalValue = parseInt(fpsElement.textContent.replace(/[^\d]/g, ''));
            if (!isNaN(finalValue)) {
                animateFPS(fpsElement, finalValue);
            }
        }
    });
}

// Funzione per animare i numeri FPS
function animateFPS(element, finalValue) {
    const duration = 800; // 800ms per l'animazione
    const startTime = performance.now();
    const startValue = 0;
    
    function update(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        
        // Easing function (ease-out)
        const easeOut = 1 - Math.pow(1 - progress, 3);
        const currentValue = Math.round(startValue + (finalValue - startValue) * easeOut);
        
        element.textContent = currentValue + ' FPS';
        
        if (progress < 1) {
            requestAnimationFrame(update);
        } else {
            element.textContent = finalValue + ' FPS';
        }
    }
    
    requestAnimationFrame(update);
}

// Reviews Slider con loop infinito seamless
let currentSlide = 0;
const slider = document.getElementById('reviewsSlider');
let slides = document.querySelectorAll('.rc');
let totalSlides = slides.length;
let isTransitioning = false;

// Clona le slide per il loop infinito
if (slider && slides.length > 0) {
    const originalSlides = Array.from(slides);
    
    // Clona tutte le slide e aggiungile alla fine
    originalSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        slider.appendChild(clone);
    });
    
    // Aggiorna la lista delle slide dopo la clonazione
    slides = document.querySelectorAll('.rc');
}

function getSlidePerView() {
    return 1;
}

function updateSlider(instant = false) {
    if (!slider || slides.length === 0) return;
    
    const container = slider.parentElement;
    const card = slides[currentSlide];
    
    if (card) {
        const cardWidth = card.offsetWidth;
        const containerWidth = container.offsetWidth;
        const gap = parseFloat(getComputedStyle(slider).gap) || 16;
        
        // Centra la card corrente
        const offset = (currentSlide * (cardWidth + gap)) - (containerWidth / 2) + (cardWidth / 2);
        
        // Se instant è true, disabilita temporaneamente la transizione
        if (instant) {
            slider.style.transition = 'none';
            slider.style.transform = `translateX(-${offset}px)`;
            // Force reflow
            slider.offsetHeight;
            slider.style.transition = '';
        } else {
            slider.style.transform = `translateX(-${offset}px)`;
        }
    }
    
    // Update center card highlight
    slides.forEach((slide, index) => {
        slide.classList.remove('center');
        if (index === currentSlide) {
            slide.classList.add('center');
        }
    });
}

window.moveSlider = function(direction) {
    if (isTransitioning) return;
    
    isTransitioning = true;
    currentSlide += direction;
    
    updateSlider();
    
    // Dopo la transizione, controlla se siamo alle slide clonate
    setTimeout(() => {
        // Se siamo oltre l'ultima slide originale, torna alla prima
        if (currentSlide >= totalSlides) {
            currentSlide = 0;
            updateSlider(true); // Instant jump senza animazione
        }
        // Se siamo prima della prima slide, vai all'ultima originale
        else if (currentSlide < 0) {
            currentSlide = totalSlides - 1;
            updateSlider(true);
        }
        
        isTransitioning = false;
    }, 500); // Durata della transizione CSS
}

if (slider && slides.length > 0) {
    // Inizializza immediatamente la prima card come centrata
    slides[0].classList.add('center');
    
    // Funzione per centrare la card corrente
    function centerCurrentSlide() {
        const container = slider.parentElement;
        const card = slides[currentSlide];
        
        if (card && container) {
            const cardWidth = card.offsetWidth;
            const containerWidth = container.offsetWidth;
            const gap = parseFloat(getComputedStyle(slider).gap) || 16;
            
            const offset = (currentSlide * (cardWidth + gap)) - (containerWidth / 2) + (cardWidth / 2);
            slider.style.transform = `translateX(-${offset}px)`;
        }
    }
    
    // Attendi che le immagini e il layout siano pronti
    window.addEventListener('load', () => {
        setTimeout(centerCurrentSlide, 50);
    });
    
    // Auto scroll every 3 seconds con loop infinito
    setInterval(() => {
        if (!isTransitioning) {
            isTransitioning = true;
            currentSlide++;
            
            updateSlider();
            
            setTimeout(() => {
                // Se siamo alle slide clonate, torna istantaneamente alle originali
                if (currentSlide >= totalSlides) {
                    currentSlide = 0;
                    updateSlider(true);
                }
                isTransitioning = false;
            }, 500);
        }
    }, 3000);

    window.addEventListener('resize', updateSlider);
}

// Initialize Lucide Icons
if (typeof lucide !== 'undefined') {
    lucide.createIcons();
}

} // Fine protezione caricamento multiplo
